<!-- 学生票二次确认弹窗 -->
<template minapp='mpx' xlang='wxml'>
  <contact-dialog
    show="{{show}}"
    title="确认购买学生票？"
    subTitle="乘客类型为学生票"
    confirmText="购买成人票"
    cancelText="购买学生票"
    bind:cancel="cancelContactDialog"
    bind:confirm="confirmContactDialog"
  >
    <view class="inner-box">
      <view class="inner-text">·学生一年仅能购买4次优惠区间的列车</view>
      <view class="inner-text">·超过4次优惠或购买不在优惠区间的将无法取票(可能需要补差价)</view>
    </view>
  </contact-dialog>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    componentName: 'StudentConfirmDialog',
    props: {
      show: {
        type: Boolean,
        value: false
      }
    },
    methods: {
      cancelContactDialog() {
        this.$trigger('cancel')
      },
      confirmContactDialog() {
        this.$trigger('confirm')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .inner-box
    background #F6F7F8
    padding 8px
    font-size 12px 
    line-height 16px
    color #666
    margin 24px 0
    border-radius 8px
    .inner-text
      margin-top 4px
      &:first-child
        margin-top 0
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'contact-dialog': './index'
    }
  }
</script>

